/**
 * Home's Workflows tab: the most recently run first, split into Failing
 * (open) and Others (folded) while there are both.
 *
 * @module components/home/HomeWorkflowsList
 */
import type { HomeGlance } from "./homeGlance.logic";
import { HomeListEmpty } from "./HomeListEmpty";
import { HomeSplitList } from "./HomeSplitList";
import { workflowList } from "./homeTabs.logic";
import { HomeWorkflowRow } from "./HomeWorkflowRow";

export function HomeWorkflowsList({
  glance,
  orgSegment,
  now,
}: {
  readonly glance: HomeGlance;
  readonly orgSegment: string;
  readonly now: number;
}) {
  if (glance.workflows.length === 0) return <HomeListEmpty>No workflows yet</HomeListEmpty>;
  return (
    <HomeSplitList
      list={workflowList(glance)}
      labels={{ needsHand: "Failing", rest: "Others" }}
      row={(workflow) => <HomeWorkflowRow key={workflow.id} workflow={workflow} orgSegment={orgSegment} now={now} />}
    />
  );
}
